declare namespace $ {

	type $mol_image__uri_bog_blitz_lobby_game_option_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_option['image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	export class $bog_blitz_lobby_game_option extends $mol_button_major {
		selected( ): string
		correct( ): string
		attr( ): ({ 
			'data-selected': ReturnType< $bog_blitz_lobby_game_option['selected'] >,
			'data-correct': ReturnType< $bog_blitz_lobby_game_option['correct'] >,
		})  & ReturnType< $mol_button_major['attr'] >
		image_uri( ): string
		Option_image( ): $mol_image
	}
	
}

//# sourceMappingURL=option.view.tree.d.ts.map